<template>
  <div class="row">
    <div class="col-md-8 col-sm-12">
      <Title class="col-12 mb-2" :page="page" />
      <BreadCrumb :page="page" class="ml-4" />
    </div>
    <div class="col-md-4 col-sm-12 text-right mt-4">
      <ActionButton
        class="btn btn-green outline-success"
        i="fas fa-arrow-circle-left"
        type="button"
        @click="$router.go(-1)"
      >
        Regresar
      </ActionButton>
      <ActionButton
        class="btn btn-green success"
        i="fas fa-save"
        type="button"
        @click="save()"
      >
        Guardar
      </ActionButton>
    </div>
    <div class="dropdown-divider mt-0 pb-2 w-100" />

    <div class="ml-n2 col-md-12">
      <div class="row-group w-100 pr-4 pl-4">
        <div class="col-12">
          <SectionTitle
            icon="fas fa-file-user"
            content="I. Información General del Estudiante"
            container-class="tag-badge-main-info mt-4 mb-4 mr-0 pr-0"
          />
        </div>
        <RowCardItem id="serviceInfo" :hide-icon="true" class="ml-2">
          <div slot="header" class="row ml-n5">
            <div
              class="d-flex align-items-start flex-fill col-md-2 col-sm-6 ml-md-n3 ml-sm-0"
            >
              <div class="icon-container">
                <em class="fas fa-address-book text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Nombre:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.name }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start flex-fill col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-address-book text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">SIE:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.sie }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start flex-fill col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-ballot-check text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Servicio:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.disciplineName }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start flex-fill col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-ballot-check text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Modalidad:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.modalityTypeName }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start flex-fill col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-ballot-check text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Frecuencia:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.frequecy }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start flex-fill col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-ballot-check text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Duración:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.duration }}
                </span>
              </div>
            </div>
          </div>
        </RowCardItem>
      </div>
      <div>
        <remedy-request-form
          ref="_remedyRequestRef"
          :info="ProvisionalRemedyRequest"
        />
      </div>
      <div class="col-12 text-right mt-4">
        <FixedBottomSaveButton :offset="200" @click="save" />
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/common/page/Title';
import BreadCrumb from '@/components/common/page/BreadCrumb';
import { SectionTitle } from '@/components/pei/shared';
import ActionButton from '@/components/common/ActionButton';
import mixAlert from '@/mixin/alert.mixin';
import RowCardItem from '@/components/common/rowcard/RowCardItem';
import RemedyRequestForm from '@/components/common/RemedyRequest/Form';
import FixedBottomSaveButton from '@/components/common/FixedBottomSaveButton';

export default {
  name: 'ProvisionalRemedyRequest',
  mixins: [mixAlert],
  components: {
    Title,
    BreadCrumb,
    SectionTitle,
    ActionButton,
    RowCardItem,
    RemedyRequestForm,
    FixedBottomSaveButton,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Solicitud de Remedio Provisional',
        routes: [
          'Inicio',
          'PEI',
          'Manejo de Referidos',
          'Historial de Servicio',
        ],
      },
      ProvisionalRemedyRequest: {
        name: null,
        sie: null,
        disciplineName: null,
        modalityTypeName: null,
        frequecy: null,
        duration: null,
      },
    };
  },
  methods: {
    save() {
      this.$refs._remedyRequestRef.save();
    },
  },
  props: {},
  async created() {
    this.ProvisionalRemedyRequest = {
      ...this.$store.state.ProvisionalRemedyRequestRef,
      hasServiceDetails: true,
    };
  },
};
</script>

<style scoped lang="scss">
.main-content {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.top-radius {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.bottom-divider {
  border-bottom: 1px solid lightgray;
  border-bottom-width: thin;
}
.radius-5 {
  border-radius: 5px;
}
.fs-16 {
  font-size: 16px;
}
.row.w-100.font-weight-regular {
  font-weight: normal;
}

.pd {
  padding-top: 10px;
}
.service-content {
  border: #f4f6f3 solid 18px;
  border-radius: 5px;
  opacity: 1;
}
.adjust-height {
  height: 69px;
}
.input-group-prepend {
  padding-top: 29px;
  color: #ff7058;
}
.input-group-text {
  color: #ff7058;
}
.email > .input-label {
  margin-left: -36px;
}

.icon-container {
  margin-top: 3px;
  margin-right: 12px;
  .far,
  .fas {
    font-size: 20px;
  }
}
.data-title {
  font-size: 16px;
}

::v-deep .tag-badge-main-info {
  width: auto !important;
  .tag-badge-title-info {
    padding-right: 10px;
  }
}

@media only screen and (max-width: 768px) {
  ::v-deep .fixed-button-custom {
    left: 0px;
  }

  ::v-deep .tag-badge-main-info {
    width: 100%;
    .tag-badge-title-info {
      font-size: 0.8rem;
    }
  }
}
</style>
